import { Platform } from 'react-native';
import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import {
  FacebookAuthProvider,
  GoogleAuthProvider,
  OAuthProvider,
  getAuth,
  signInWithPopup,
} from 'firebase/auth';
import { firebaseConfig, hasFirebaseConfig } from '../config/firebase';

export type SocialProvider = 'google' | 'apple' | 'facebook';

function getFirebaseApp(): FirebaseApp {
  if (!hasFirebaseConfig()) {
    throw new Error('Ứng dụng chưa cấu hình Firebase.');
  }

  return getApps()[0] ?? initializeApp(firebaseConfig);
}

function createProvider(provider: SocialProvider) {
  if (provider === 'google') {
    const google = new GoogleAuthProvider();
    google.addScope('email');
    google.addScope('profile');
    return google;
  }

  if (provider === 'facebook') {
    const facebook = new FacebookAuthProvider();
    facebook.addScope('email');
    return facebook;
  }

  const apple = new OAuthProvider('apple.com');
  apple.addScope('email');
  apple.addScope('name');
  return apple;
}

export async function signInWithFirebaseProvider(provider: SocialProvider) {
  if (Platform.OS !== 'web') {
    throw new Error('Đăng nhập Firebase bằng mạng xã hội hiện hỗ trợ trên bản web. Bản iOS/Android cần cấu hình client ID riêng cho Google, Apple và Facebook.');
  }

  const auth = getAuth(getFirebaseApp());
  const result = await signInWithPopup(auth, createProvider(provider));
  return result.user.getIdToken(true);
}
